<div class="widthClass">
  <mat-toolbar mat-dialog-title class="mat-accent m-0">
    <div fxFlex fxLayout="row" fxLayoutAlign="space-between center">
      <span class="title dialog-title">Add Payment</span>
      <button (click)="dialogRef.close()" aria-label="Close dialog">
        <mat-icon class="closebtn">close</mat-icon>
      </button>
    </div>
  </mat-toolbar>
  <mat-progress-bar *ngIf="loading" mode="query" class="my-color" mode="query" value="value" [bufferValue]="bufferValue">
  </mat-progress-bar>

  <div style="margin:30px;">
      <div>
        <table>
          <tr>
            <td>Case Number</td>
            <td>: &nbsp; &nbsp; {{ duePayment.caseNumber }}</td>
          </tr>
          <tr>
            <td>Ward Name</td>
            <td>: &nbsp; &nbsp; {{ duePayment.ward_name }}</td>
          </tr>
          <tr>
            <td>Amount</td>
            <td>: &nbsp; &nbsp; ${{ duePayment.amount/100 }}</td>
          </tr>
          <tr>
            <td>Description</td>
            <td>: &nbsp; &nbsp; {{ duePayment.description }}</td>
          </tr>
          <tr>
            <td>Paid by</td>
            <td>: &nbsp; &nbsp; {{ duePayment.user }}</td>
          </tr>
        </table>
      </div>
     
      <br>
      <div>
        <form name="paymentForm" [formGroup]="paymentForm" class="alert-form w-100-p" fxLayout="column" fxFlex>
          <mat-input-container class="w-100-p">
            <textarea rows="8" matInput formControlName="message" name="message" placeholder="Additional information such as check details etc." 
              mat-maxlength="250" max-rows="4" cdkFocusInitial>
            </textarea>
          </mat-input-container>
        </form>
      </div>

    <div class="actionButtons">
      <button [class.loading]="loading" mat-raised-button color="accent" aria-label="Update" (click)="updatePayment()"
        [disabled]="paymentForm.invalid || loading" style="float:right;">
        <div class="spinner"></div>
        <span class="label" style="text-transform: uppercase;">Update</span>
      </button>
    </div>
    <br>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/content/common/payments/payment-form/payment-form.component.html